import { FeatureCard } from "./components/feature-card";
import { BenefitItem } from "./components/benefit-item";
import { Img } from "components";

export default function AIReelGeneration() {
  return (
    <main className="mx-auto max-w-6xl px-2 py-20 md:px-5 md:py-12 sm:px-4 sm:py-8">
      {/* Header */}
      <header className="text-center max-w-3xl mx-auto">
        <h1 className="text-balance text-5xl font-semibold tracking-tight text-[#0C0C0C] md:text-3xl sm:text-2xl">
          AI-Based Reels – Covering School Events and Birthdays
        </h1>
        <p className="mt-4 text-xs text-[#4D4D4D] text-pretty font-medium sm:text-[11px] sm:mt-3">
          Celebrate and showcase every school moment with AI-powered Reels from SooMuch.AI. From birthdays and annual
          days to sports events, teacher's day, children's day, or any other school function – our AI generates
          high-quality, engaging reels that highlight the school's identity and keep your branding front and center.
        </p>
      </header>

      {/* Features grid */}
      <section className="mt-16 grid gap-6 grid-cols-12 md:mt-12 md:gap-4 sm:mt-8 sm:gap-3 sm:grid-cols-1">
        <div className="col-span-7 sm:col-span-1">
          <FeatureCard
            title="Event Reels"
            description="Upload photos from any school event. SooMuch.AI adds beautiful background music and generates a highlight reel to showcase the event."
            media={
              <div className="relative z-10 w-full flex items-center justify-center min-h-80 max-h-80 rounded-3xl overflow-hidden md:min-h-64 md:max-h-64 sm:min-h-48 sm:max-h-48 sm:rounded-2xl">
                <Img
                  src="/images/new-landing-page/aiReelFirstImage.svg"
                  alt="Event reels phone preview"
                  className="object-cover w-full h-full"
                />
              </div>
            }
          />
        </div>
        <div className="col-span-5 sm:col-span-1">
          <FeatureCard
            title="Birthday Reels"
            description="Simply upload the picture of a child whose birthday it is, and our AI creates a personalized birthday reel branded for the school."
            media={
              <div className="relative z-10 w-full flex items-center justify-center min-h-80 max-h-80 rounded-3xl overflow-hidden md:min-h-64 md:max-h-64 sm:min-h-48 sm:max-h-48 sm:rounded-2xl">
                <Img
                  src="/images/new-landing-page/aiReelSecondImage.svg"
                  alt="Birthday reels preview"
                  className="object-contain w-full h-full"
                />
              </div>
            }
          />
        </div>
        <div className="col-span-5 sm:col-span-1">
          <FeatureCard
            title="Distribution"
            description="Reels can be shared on the school's social media handles and the Parent App, maximizing engagement and reach."
            media={
              <div className="relative z-10 w-full flex items-center justify-center min-h-80 max-h-80 rounded-3xl overflow-hidden md:min-h-64 md:max-h-64 sm:min-h-48 sm:max-h-48 sm:rounded-2xl">
                <Img
                  src="/images/new-landing-page/aiReelThirdImage.svg"
                  alt="Share to social preview"
                  className="object-contain w-full h-full"
                />
              </div>
            }
          />
        </div>
        <div className="col-span-7 sm:col-span-1">
          <FeatureCard
            title="School Branding Highlight"
            description="All reels are automatically created under the school's branding, ensuring consistency and professional presentation."
            media={
              <div className="relative z-10 w-full flex items-center justify-center min-h-80 max-h-80 rounded-3xl overflow-hidden md:min-h-64 md:max-h-64 sm:min-h-48 sm:max-h-48 sm:rounded-2xl">
                <Img
                  src="/images/new-landing-page/aiReelForthImage.svg"
                  alt="School branding preview"
                  className="object-contain w-full h-full"
                />
              </div>
            }
          />
        </div>
      </section>

      {/* Benefits */}
      <section className="mt-14 md:mt-10 sm:mt-8">
        <h2 className="text-center text-2xl font-semibold md:text-xl sm:text-lg">
          How it benefits you:
        </h2>
        <div className="mt-6 flex flex-wrap justify-center gap-6 md:gap-4 sm:mt-4 sm:gap-3">
          <BenefitItem>Increases parent engagement and pride in school events.</BenefitItem>
          <BenefitItem>Highlights every school event and birthday in a professional, branded way.</BenefitItem>
        </div>
        <div className="mt-6 flex flex-wrap justify-center gap-6 md:gap-4 sm:mt-3 sm:gap-3">
          <BenefitItem>Reduces staff effort in content creation while maintaining high-quality output.</BenefitItem>
          <BenefitItem>Boosts social media visibility and reach.</BenefitItem>
        </div>
      </section>
    </main>
  );
}
